import { __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import BadgeDS from '@wix/da-ds/pkg/Badge';
import styles from './Badge.scss';
var Badge = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'large' : _b, badgeProps = __rest(_a, ["className", "size"]);
    var one_cake = useFlag('one_cake');
    if (one_cake) {
        return (React.createElement(BadgeDS, { badge: badgeProps, type: "normal", size: size === 'large' ? 24 : 16 }));
    }
    var badgeTitle = badgeProps.title, description = badgeProps.description, stackCount = badgeProps.stackCount, name = badgeProps.name, images = badgeProps.images;
    var title = badgeTitle;
    if (description) {
        title += ": ".concat(description);
    }
    if (stackCount) {
        title += " (".concat(stackCount, ")");
    }
    return (React.createElement("div", { className: classnames(styles['root'], styles["badge-".concat(name)], styles["size-".concat(size)], className), title: title }, images.map(function (image, index) {
        var imageClassnames = image.className
            ? image.className.split(' ')
            : [];
        return (React.createElement("img", { key: index, src: image.imageUrl, className: classnames(styles['badge-image'], imageClassnames.map(function (c) { return styles[c]; })), alt: title, loading: "lazy" }));
    })));
};
Badge.displayName = 'Badge';
export default Badge;
//# sourceMappingURL=Badge.js.map